export const environment = {
  production: true,
  apiUrl: 'https://audit.smartspecialisation.tech/api/',
  hasBuildInfo: true,
  buildDate: '2019-07-16T08:04:18Z',
  commitDate: '2019-07-16T10:01:41+02:00',
  commitHash: '4fce296bc698',
  environmentName: 'prod',
};
